import { useToast } from './useToast'

export { useToast }
export default useToast
